export type OSType = 'apple' | 'windows' | 'linux' | 'android' | 'other';
